<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import type { ObservationSpecieResource } from "@carnet/api/backoffice";

// Les destinations sont fournies par l'app hôte (web : `useObservationSpecieLinks`,
// qui reporte les filtres de l'URL courante) — absentes, le lien correspondant est masqué.
defineProps<{
  specie: ObservationSpecieResource;
  photosTo?: RouteLocationRaw;
  detailTo?: RouteLocationRaw;
}>();

const { t } = useI18n();
</script>

<template>
  <AppTileSpecie :specie="specie">
    <div v-if="specie.observations || specie.sites" class="flex items-center gap-2 text-sm font-semibold not-last:mb-4">
      <UBadge v-if="specie.observations" variant="soft" size="sm" class="leading-5">{{ t("observations.count", specie.observations) }}</UBadge>
      <UBadge v-if="specie.sites" variant="soft" size="sm" class="leading-5">{{ t("observations.sites", specie.sites) }}</UBadge>
    </div>

    <ul class="flex flex-col items-start space-y-2.5 pb-0.5">
      <li v-if="specie.observationsWithPhotos && photosTo">
        <UButton :to="photosTo" variant="link" color="blue" trailing-icon="icon:eye">
          {{ t("observations.viewPhotos") }} ({{ specie.observationsWithPhotos }})
        </UButton>
      </li>

      <li v-if="detailTo">
        <UButton :to="detailTo" variant="link" color="blue" trailing-icon="icon:arrowRight">
          {{ t("observations.viewSpecie") }}
        </UButton>
      </li>
    </ul>
  </AppTileSpecie>
</template>
